var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.923 22.463c0 .285-.182.734-.93 1.296-.732.55-1.854 1.089-3.33 1.558-2.94.936-7.063 1.53-11.663 1.53-4.6 0-8.723-.594-11.663-1.53-1.476-.47-2.597-1.007-3.329-1.558-.748-.562-.93-1.011-.93-1.296 0-.286.182-.734.93-1.297.732-.55 1.853-1.088 3.329-1.558 2.94-.935 7.064-1.53 11.663-1.53 4.6 0 8.723.595 11.663 1.53 1.476.47 2.598 1.008 3.33 1.558.748.563.93 1.011.93 1.297z",
    stroke: "#32A3F5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.846 8.11c0 1.935-.965 4.592-2.458 7.268-1.293 2.316-2.915 4.526-4.446 6.13-1.668-1.588-3.286-3.793-4.534-6.116-1.428-2.656-2.298-5.325-2.298-7.282 0-3.852 3.086-6.956 6.868-6.956 3.783 0 6.868 3.104 6.868 6.956z",
    stroke: "#32A3F5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 2,
    stroke: "#32A3F5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.20345779.svg";
export { ForwardRef as ReactComponent };